export const OVERFLOW_THRESHOLD = 4;
export const MAX_VISIBLE_NAMES = 2;

/**
 * Truncates a list of names for display purposes
 * Returns visible names and hidden names for overflow tooltip
 */
export function truncatedNames(names: string[]): {
  visibleNames: string[];
  hiddenNames: string[];
  shouldShowHiddenNames: boolean;
} {
  const shouldTruncate = names.length >= OVERFLOW_THRESHOLD;
  const visibleNames = shouldTruncate ? names.slice(0, MAX_VISIBLE_NAMES) : names;
  const hiddenNames = shouldTruncate ? names.slice(MAX_VISIBLE_NAMES) : [];

  return {
    visibleNames,
    hiddenNames,
    shouldShowHiddenNames: !!hiddenNames.length,
  };
}
